import CurrencyFormatter from "currency-formatter";
import GeneralHelper from "../../utils/GeneralHelper";

export class GeneralAcquisition {
  constructor({
    attorneyFees = 0,
    escrowServiceFees = 0,
    appraisalFees = 0,
    accountantsFees = 0,
    franchiseLicenseAgreementTransferFees = 0,
    businessBrokerageFees = 0,
    fillingsRecordingFees = 0,
    customFields = []
  }) {
    this.attorneyFees = attorneyFees
    this.escrowServiceFees = escrowServiceFees
    this.appraisalFees = appraisalFees
    this.accountantsFees = accountantsFees
    this.franchiseLicenseAgreementTransferFees = franchiseLicenseAgreementTransferFees
    this.businessBrokerageFees = businessBrokerageFees
    this.fillingsRecordingFees = fillingsRecordingFees
    this.customFields = customFields
  }

  get totalClosingCostsToBePaidByPurchaser() {
    return (
      this.attorneyFees
      + this.escrowServiceFees
      + this.appraisalFees
      + this.accountantsFees
      + this.franchiseLicenseAgreementTransferFees
      + this.businessBrokerageFees
      + this.fillingsRecordingFees
      + GeneralHelper.sumObjectAttributeFromArray(this.customFields, "value")
    )
  }

  get totalClosingCostsToBePaidByPurchaserFormatted() {
    return CurrencyFormatter.format(this.totalClosingCostsToBePaidByPurchaser, { code: "USD", symbol: "$" })
  }
}

export class AcquisitionLicensesTaxesPermitsAndFees {
  constructor({
    salesTaxOnEquipmentPurchased = 0,
    correctionOfCodeViolations = 0,
    franchisorTrainingExpenses = 0,
    liquorLicense = 0,
    cityCountyAndStateBusinessLicensesAndPermits = 0,
    loanFeesForThirdPartyPurchaseLoan = 0,
    deferredMaintenanceExpenses = 0,
    vehicleRegistrationAndLicensingFees = 0,
    travelExpenses = 0,
    prepaidPropertyDamageAndLiabilityInsurancePremiums = 0,
    customFields = []
  }) {
    this.salesTaxOnEquipmentPurchased = salesTaxOnEquipmentPurchased
    this.correctionOfCodeViolations = correctionOfCodeViolations
    this.franchisorTrainingExpenses = franchisorTrainingExpenses
    this.liquorLicense = liquorLicense
    this.cityCountyAndStateBusinessLicensesAndPermits = cityCountyAndStateBusinessLicensesAndPermits
    this.loanFeesForThirdPartyPurchaseLoan = loanFeesForThirdPartyPurchaseLoan
    this.deferredMaintenanceExpenses = deferredMaintenanceExpenses
    this.vehicleRegistrationAndLicensingFees = vehicleRegistrationAndLicensingFees
    this.travelExpenses = travelExpenses
    this.prepaidPropertyDamageAndLiabilityInsurancePremiums = prepaidPropertyDamageAndLiabilityInsurancePremiums
    this.customFields = customFields
  }

  get totalAdditionalPurchaserCashPayoutRequirements() {
    return (
      this.salesTaxOnEquipmentPurchased
      + this.correctionOfCodeViolations
      + this.franchisorTrainingExpenses
      + this.liquorLicense
      + this.cityCountyAndStateBusinessLicensesAndPermits
      + this.loanFeesForThirdPartyPurchaseLoan
      + this.deferredMaintenanceExpenses
      + this.vehicleRegistrationAndLicensingFees
      + this.travelExpenses
      + this.prepaidPropertyDamageAndLiabilityInsurancePremiums
      + GeneralHelper.sumObjectAttributeFromArray(this.customFields, "value")
    )
  }

  get totalAdditionalPurchaserCashPayoutRequirementsFormatted() {
    return CurrencyFormatter.format(this.totalAdditionalPurchaserCashPayoutRequirements, {
      code: "USD",
      symbol: "$"
    })
  }
}

export class PrePaidAssetNeeded {
  constructor({
    leaseDeposit = 0,
    utilityCompanyDeposit = 0,
    productLiabilityAndComprehensiveInsurancePrepayment = 0,
    workersCompensationInsurancePrepayment = 0,
    prepaidDeposits = 0,
    prepaidExpenses = 0,
    liquorLicense = 0,
    landlordBond = 0,
    customFields = []
  }) {
    this.leaseDeposit = leaseDeposit
    this.utilityCompanyDeposit = utilityCompanyDeposit
    this.productLiabilityAndComprehensiveInsurancePrepayment = productLiabilityAndComprehensiveInsurancePrepayment
    this.workersCompensationInsurancePrepayment = workersCompensationInsurancePrepayment
    this.prepaidDeposits = prepaidDeposits
    this.prepaidExpenses = prepaidExpenses
    this.liquorLicense = liquorLicense
    this.landlordBond = landlordBond
    this.customFields = customFields
  }

  get totalAdditionalPurchaserCashPayoutForAssets() {
    return (
      this.leaseDeposit
      + this.utilityCompanyDeposit
      + this.productLiabilityAndComprehensiveInsurancePrepayment
      + this.workersCompensationInsurancePrepayment
      + this.prepaidDeposits
      + this.prepaidExpenses
      + this.liquorLicense
      + this.landlordBond
      + GeneralHelper.sumObjectAttributeFromArray(this.customFields, "value")
    )
  }

  get totalAdditionalPurchaserCashPayoutForAssetsFormatted() {
    return CurrencyFormatter.format(this.totalAdditionalPurchaserCashPayoutForAssets, {
      code: "USD",
      symbol: "$"
    })
  }
}

export class WorkingCapitalNeededAtClosing {
  constructor({
    operatingCash = 0,
    accountsReceivable = 0,
    inventory = 0,
    customFields = []
  }) {
    this.operatingCash = operatingCash
    this.accountsReceivable = accountsReceivable
    this.inventory = inventory
    this.customFields = customFields
  }

  get totalCashPaymentForAllAdditionalAssetsToBePurchased() {
    return (
      this.operatingCash
      + this.accountsReceivable
      + this.inventory
      + GeneralHelper.sumObjectAttributeFromArray(this.customFields, "value")
    )
  }

  get totalCashPaymentForAllAdditionalAssetsToBePurchasedFormatted() {
    return CurrencyFormatter.format(this.totalCashPaymentForAllAdditionalAssetsToBePurchased, {
      code: "USD",
      symbol: "$"
    })
  }
}

export default class PurchaserAcquisitionExpenses {
  /**
   *
   * @param {GeneralAcquisition} generalAcquisition
   * @param {AcquisitionLicensesTaxesPermitsAndFees} acquisitionLicensesTaxesPermitsAndFees
   * @param {PrePaidAssetNeeded} prePaidAssetsNeeded
   * @param {WorkingCapitalNeededAtClosing} workingCapitalNeededAtClosing
   */
  constructor({
    generalAcquisition,
    acquisitionLicensesTaxesPermitsAndFees,
    prePaidAssetsNeeded,
    workingCapitalNeededAtClosing
  }) {
    this.generalAcquisition = generalAcquisition
    this.acquisitionLicensesTaxesPermitsAndFees = acquisitionLicensesTaxesPermitsAndFees
    this.prePaidAssetsNeeded = prePaidAssetsNeeded
    this.workingCapitalNeededAtClosing = workingCapitalNeededAtClosing
  }

  get additionalCapitalNeededAtClosing() {
    return (
      this.generalAcquisition.totalClosingCostsToBePaidByPurchaser
      + this.acquisitionLicensesTaxesPermitsAndFees.totalAdditionalPurchaserCashPayoutRequirements
      + this.prePaidAssetsNeeded.totalAdditionalPurchaserCashPayoutForAssets
      + this.workingCapitalNeededAtClosing.totalCashPaymentForAllAdditionalAssetsToBePurchased
    )
  }

  get additionalCapitalNeededAtClosingFormatted() {
    return CurrencyFormatter.format(this.additionalCapitalNeededAtClosing, { code: "USD", symbol: "$" })
  }
}